export default __webpack_public_path__ + "static/media/4.fd6c7ced.png";